// extracted by css-extract-rspack-plugin
export default {"root":"ProjectTimeMask_root__RpNMl","header":"ProjectTimeMask_header__8EfKe","left":"ProjectTimeMask_left__N0kQt","dialogWrapper":"ProjectTimeMask_dialogWrapper__V1t2G"};